import React from 'react';

import { useGuide } from '@knocklabs/react';

import { ButtonClickHandler, ImageClickHandler } from './types';

export const isValidHttpUrl = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const useVatixGuide = <T>(
  type: 'card' | 'banner' | 'modal',
  guideKey: string | undefined
): {
  guide: ReturnType<typeof useGuide<T>>['guide'];
  step: ReturnType<typeof useGuide<T>>['step'];
  colorMode: ReturnType<typeof useGuide<T>>['colorMode'];
  onDismiss: () => void;
  onButtonClick: ButtonClickHandler;
  onImageClick: ImageClickHandler;
} => {
  const { guide, step, colorMode } = useGuide<T>({ key: guideKey, type: `vatix-${type}` });

  React.useEffect(() => {
    step?.markAsSeen();
  }, [step]);

  const onDismiss = (): void => {
    step?.markAsArchived();
  };
  const onButtonClick: ButtonClickHandler = (e, button) => {
    step?.markAsInteracted({
      metadata: { name: button.name, text: button.text, action: button.action, type: 'button_click' },
    });
    if (isValidHttpUrl(button.action)) {
      setTimeout(() => window.location.assign(button.action), 200);
    }
  };
  const onImageClick: ImageClickHandler = (e, image) => {
    step?.markAsInteracted({ metadata: { url: image.url, action: image.action, type: 'image_click' } });
  };

  return { guide, step, colorMode, onDismiss, onButtonClick, onImageClick };
};
